module.exports = __webpack_public_path__ + "img/catering_menu_12.02512713.jpg";